import type { ComparisonAdjustment } from '../types/hrmsRegularizationReview.types'

export const REGULARIZATION_REVIEW_TEXTS = {
  title: 'Review Regularization Request',
  subtitle:
    "Review the employee's requested attendance correction before approving or rejecting it.",
  permissionNote:
    'Values are locked for review. HR/Admin cannot directly edit requested times.',
}

function parseTimeToMinutes(timeStr?: string): number | null {
  if (!timeStr || timeStr === 'none') return null
  const [hStr, mStr] = timeStr.split(':')
  const h = parseInt(hStr, 10)
  const m = parseInt(mStr, 10)
  if (isNaN(h) || isNaN(m)) return null
  return h * 60 + m
}

export function formatMinutesDiff(minutes: number): string {
  if (minutes < 60) return `${minutes}m`
  const hrs = Math.floor(minutes / 60)
  const mins = minutes % 60
  return mins > 0 ? `${hrs}h ${mins}m` : `${hrs}h`
}

export function computeAdjustments(
  currentCheckIn?: string,
  currentCheckOut?: string,
  requestedCheckIn?: string,
  requestedCheckOut?: string
): ComparisonAdjustment[] {
  const adjustments: ComparisonAdjustment[] = []

  const curIn = parseTimeToMinutes(currentCheckIn)
  const reqIn = parseTimeToMinutes(requestedCheckIn)

  if (curIn === null && reqIn !== null) {
    adjustments.push({ field: 'Check In', kind: 'added' })
  } else if (curIn !== null && reqIn !== null && curIn !== reqIn) {
    if (reqIn < curIn) {
      adjustments.push({ field: 'Check In', kind: 'earlier', minutes: curIn - reqIn })
    } else {
      adjustments.push({ field: 'Check In', kind: 'later', minutes: reqIn - curIn })
    }
  }

  const curOut = parseTimeToMinutes(currentCheckOut)
  const reqOut = parseTimeToMinutes(requestedCheckOut)

  if (curOut === null && reqOut !== null) {
    adjustments.push({ field: 'Check Out', kind: 'added' })
  } else if (curOut !== null && reqOut !== null && curOut !== reqOut) {
    if (reqOut < curOut) {
      adjustments.push({ field: 'Check Out', kind: 'earlier', minutes: curOut - reqOut })
    } else {
      adjustments.push({ field: 'Check Out', kind: 'later', minutes: reqOut - curOut })
    }
  }

  return adjustments
}
